module.exports = __webpack_public_path__ + "static/media/product-3.ca9f99f6.jpg";